/* one delegated handler for every bouquet card on the page.
   Extracted 2026-07-14 from the inline <script> in snippets/tk-bqcard-info.liquid
   so it ships ONCE (cacheable asset) instead of being duplicated per card, matching
   the tk-flcard.js / tk-bqcard.css asset pattern used elsewhere. This is a tidy-up
   for consistency — on the bouquets/occasion pages gzip already collapsed the
   duplicate copies, so the wire saving is ~0; behaviour is byte-for-byte identical
   and the window.__tkBqc guard keeps it idempotent however many cards reference it. */
if (!window.__tkBqc) {
  window.__tkBqc = 1;

  function tkBqcPath(href) {
    try { return new URL(href, window.location.href).pathname; } catch (e) { return ''; }
  }

  /* Repoint every link inside `card` that points at this product at `href`,
     leaving the swatches — which each carry their own variant — alone. */
  function tkBqcRetarget(card, href) {
    var path = tkBqcPath(href);
    if (!path) return;
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a.hasAttribute('data-tk-bqc-sw')) return;
      if (tkBqcPath(a.getAttribute('href')) !== path) return;
      a.href = href;
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-tk-bqc-sw]');
    if (!sw) return;
    e.preventDefault();
    var root = sw.closest('[data-tk-bqc]');
    if (!root) return;
    root.querySelectorAll('[data-tk-bqc-sw]').forEach(function (s) {
      var on = s === sw;
      s.classList.toggle('is-selected', on);
      s.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var price = root.querySelector('[data-tk-bqc-price]');
    if (price && sw.dataset.price) price.textContent = sw.dataset.price;
    var pill = root.querySelector('[data-tk-bqc-pill]');
    if (pill) pill.textContent = sw.dataset.pillLabel || 'Hand-crocheted';
    var name = root.querySelector('[data-tk-bqc-name]');
    if (name) name.href = sw.getAttribute('href');
    // Point EVERY link on the native card at the chosen variant. Horizon renders
    // more than one: the invisible full-surface overlay (.product-card__link) AND
    // a second anchor wrapping the gallery photo (ref="cardGalleryLink") which
    // sits ON TOP of it. We used to retarget only the overlay, so a click on the
    // PHOTO — the biggest target on the card — still opened the product's default
    // variant and threw away the swatch the shopper had just picked (Harry,
    // 2026-07-28). Matching on the product path rather than on class names covers
    // any further link a Horizon update adds. Occasion cards have no
    // <product-card> ancestor; tk-occasion-grid's own handler moves their media
    // link, and the name link above is shared by both surfaces.
    var card = root.closest('product-card');
    if (card) tkBqcRetarget(card, sw.getAttribute('href'));
    // show the chosen variant's own photo in the gallery (restore the
    // product photo when the variant has no image of its own)
    var gImg = card && card.querySelector('.card-gallery img');
    if (gImg) {
      if (gImg.dataset.tkOrigSrc === undefined) {
        gImg.dataset.tkOrigSrc = gImg.getAttribute('src') || '';
        gImg.dataset.tkOrigSrcset = gImg.getAttribute('srcset') || '';
      }
      if (sw.dataset.imgSrc) {
        gImg.src = sw.dataset.imgSrc;
        if (sw.dataset.imgSrcset) gImg.setAttribute('srcset', sw.dataset.imgSrcset);
        else gImg.removeAttribute('srcset');
      } else {
        gImg.src = gImg.dataset.tkOrigSrc;
        if (gImg.dataset.tkOrigSrcset) gImg.setAttribute('srcset', gImg.dataset.tkOrigSrcset);
        else gImg.removeAttribute('srcset');
      }
    }
  });
}
